import { getDateRangeDays } from './getDateRangeDays'

export const helpersGetters = {
  getDateRangeDays,
}
